// These articulate the percentage improvement in the number of applications
// a job receives when they show salary in the given job location country.
const SHOW_SALARY_INCREASE_IN_APPLICATION_PERCENTAGES: Record<string, number> =
  {
    nz: 40, // In future change to 74% because that is impact in NZ
    au: 40,
  };

export const getPayDisplayApplicationPercentage = (
  jobLocationCountry?: string,
): number | null => {
  if (!jobLocationCountry) {
    return null;
  }
  return (
    SHOW_SALARY_INCREASE_IN_APPLICATION_PERCENTAGES[
      jobLocationCountry.toLowerCase()
    ] ?? null
  );
};
